import React, { useState, useEffect, useRef } from "react";
import { DownloadOutlined } from "@mui/icons-material";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";

import {
  getAllLeaseEventsSnoozed,
  getAllLeaseEventsIgnored,
  getLeaseEventSpreadsheet,
} from "redux/actions/leaseEventActions";
import { getLeaseSpreadsheet } from "redux/actions/leaseActions";
import { getPropertySpreadsheet } from "redux/actions/propertyActions";
import { getTransactionSpreadsheet } from "redux/actions/transactionActions";
import { Btncontainer } from "components/GridToolbar/styles";
import { convertToCSV, formatData, transformLeaseData } from "./commonfn";
import { LoadingButton } from "@mui/lab";

const Export = (props) => {
  const dispatch = useDispatch();
  const {
    data,
    filename,
    requestdata = () => {},
    columnVisibilityModel,
    rowCount
  } = props;

  const [exportData, setExportData] = useState("");
  const [isLoading, setLoading] = useState(false);
  const csvLink = useRef();
  const request = requestdata();
  const gridContext = useGridApiContext();
  const gridColumns = gridContext.current.getAllColumns();

  useEffect(() => {
    if (exportData !== "") csvLink.current.link.click();
  }, [exportData]);

  const handleClick = () => {
    setExportData("");
    setLoading(true);
    let leVisibleColumns = [];

    gridColumns.forEach((c) => {
      if (
        columnVisibilityModel[c.field] === null ||
        columnVisibilityModel[c.field]
      ) {
        leVisibleColumns.push(c.headerName);
      }
    });

    switch (filename) {
      case "LeaseEvents_all":        
        const leSsRequest = { ...request, columns: leVisibleColumns};

        dispatch(getLeaseEventSpreadsheet(leSsRequest))
          .then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.payload.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "leaseEvent.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .finally(() => {
            setLoading(false);
          });
        break;

      case "LeaseEvents_snoozed":
        const leaseSnoozeRequest = {
          ...request,
          columns: leVisibleColumns,
          leaseEventType: "snoozed",
        };

        dispatch(getLeaseEventSpreadsheet({ ...leaseSnoozeRequest}))
          .then((result) => {
              const href = URL.createObjectURL(result.payload.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "leaseEvent_snoozed.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .catch((err) => {setLoading(false)})
          .finally(() => setLoading(false));
        break;

      case "LeaseEvents_ignored":
        const leaseIgnoreRequest = {
          ...request,
          columns: leVisibleColumns,
          leaseEventType: "ignored",
        };
        
        dispatch(getLeaseEventSpreadsheet({ ...leaseIgnoreRequest}))
          .then((result) => {
              const href = URL.createObjectURL(result.payload.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "leaseEvent_ignored.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .finally(() => setLoading(false))
          .catch((err) => {
            setLoading(false);
          });
        break;

      case "Transaction":
      case "Pre-Transaction":
        let txVisibleColumns = [];

        gridColumns.forEach((c) => {
          if (
            columnVisibilityModel[c.field] === null ||
            columnVisibilityModel[c.field]
          ) {
            txVisibleColumns.push(c.headerName);
          }
        });

        const txSsRequest = { ...request, columns: txVisibleColumns };

        dispatch(getTransactionSpreadsheet(txSsRequest))
          .then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.payload.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "transaction.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .finally(() => {
            setLoading(false);
          });
        break;

      case "Properties":
        let propVisibleColumns = [];

        gridColumns.forEach((c) => {
          if (
            columnVisibilityModel[c.field] === null ||
            columnVisibilityModel[c.field]
          ) {
            propVisibleColumns.push(c.headerName);
          }
        });

        const propSsRequest = { ...request, columns: propVisibleColumns };

        dispatch(getPropertySpreadsheet(propSsRequest))
          .then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.payload.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "property.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .finally(() => {
            setLoading(false);
          });
        break;

      case "Leases":
        let leaseVisibleColumns = [];

        gridColumns.forEach((c) => {
          if (
            columnVisibilityModel[c.field] === null ||
            columnVisibilityModel[c.field]
          ) {
            leaseVisibleColumns.push(c.headerName);
          }
        });

        const leaseSsRequest = { ...request, columns: leaseVisibleColumns };

        dispatch(getLeaseSpreadsheet(leaseSsRequest))
          .then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.payload.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "lease.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
          .finally(() => {
            setLoading(false);
          });
        break;

      default:
        let formattedData = convertToCSV(
          formatData(data, gridColumns, columnVisibilityModel, filename)
        );

        setExportData(formattedData);

        setLoading(false);
        break;
    }
  };

  return (
    <Btncontainer>
      <LoadingButton
        startIcon={<DownloadOutlined />}
        loading={isLoading}
        onClick={handleClick}
        loadingPosition="start"
        variant="text"
        disabled={rowCount===0}
      >
        Download
      </LoadingButton>
      <CSVLink
        style={{ textDecoration: "none" }}
        data={exportData}
        filename={`${filename}.csv`}
        target="_blank"
        ref={csvLink}
        className="csvLinkHide"
        enclosingCharacter={`'`}
      />
    </Btncontainer>
  );
};

export default Export;
